import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import type { TelegramAgentPermissions } from "@/types/telegram";
import { DEFAULT_TELEGRAM_AGENT_PERMISSIONS } from "@/types/telegram";

interface TelegramAgentPermissionsCardProps {
  permissions: TelegramAgentPermissions;
  onChange: (next: Partial<TelegramAgentPermissions>) => void;
  disabled?: boolean;
}

const PERMISSION_ITEMS: Array<{
  key: keyof TelegramAgentPermissions;
  label: string;
  description: string;
}> = [
  {
    key: "readMessages",
    label: "Read messages",
    description: "Allow AI agents to read and analyze selected Telegram messages",
  },
  {
    key: "sendMessages",
    label: "Send messages",
    description: "Allow AI agents to send AI-generated replies",
  },
  {
    key: "createDocuments",
    label: "Create documents",
    description: "Allow AI agents to push content to the document creator sidebar",
  },
  {
    key: "indexRag",
    label: "Index to RAG",
    description: "Allow AI agents to embed Telegram content into integration RAG",
  },
  {
    key: "postToClickUp",
    label: "Post to ClickUp",
    description: "Allow AI agents to format and post deliverables to ClickUp (you pick workspace)",
  },
];

export function TelegramAgentPermissionsCard({
  permissions,
  onChange,
  disabled,
}: TelegramAgentPermissionsCardProps) {
  const merged = { ...DEFAULT_TELEGRAM_AGENT_PERMISSIONS, ...permissions };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">AI agent permissions</CardTitle>
        <CardDescription>
          Control what AI agents can do with your Telegram account. All off by default.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {PERMISSION_ITEMS.map((item) => (
          <div key={item.key} className="flex items-start justify-between gap-4">
            <div className="space-y-0.5">
              <Label htmlFor={`tg-perm-${item.key}`}>{item.label}</Label>
              <p className="text-xs text-muted-foreground">{item.description}</p>
            </div>
            <Switch
              id={`tg-perm-${item.key}`}
              checked={merged[item.key]}
              disabled={disabled}
              onCheckedChange={(checked) => onChange({ [item.key]: checked })}
            />
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
